
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro-settings/[slug]",
      function () {
        return require("private-next-pages/pro-settings/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro-settings/[slug]"])
      });
    }
  